import React, {useContext} from "react";
import editLight from "../../../../../../assets/editLight.svg";
import editDark from "../../../../../../assets/editDark.svg";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {MessageBottomContainerContext, MessageContext} from "../../../Message.tsx";

interface EditProps {}

const Edit: React.FC<EditProps> = () => {
    const { isPreview } = useContext(MessageContext);
    const { group, setEditedContent } = useContext(MessageBottomContainerContext);

    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;

    const handleEditClick = () => {
        if (isPreview) return;
        setDynamicStateObj({editingId: group.index});
        const deepCopyContent = group.messages[0].message.content.map((item: any) => ({
            ...item
        }));
        if (!group.messages[0].message.content.some((item: any) => item.type === "text")) {
            deepCopyContent.push({ type: "text", text: "" });
        }
        setEditedContent(deepCopyContent);
    };

    return (
        <button
            className={`h-5 w-5 ${isPreview ? 'opacity-50' : 'cursor-pointer'}`}
            onClick={handleEditClick}
            disabled={isPreview}
        >
            <img
                src={`${theme === 'dark' ? editLight : editDark}`}
                alt="Edit"
                className={isPreview ? 'filter grayscale' : ''}
            />
        </button>
    )
}

export default Edit;
